import {LocationSubDivisionModel} from './location-sub-division.model';

export class LocationFormatter {
  permanentAddress: LocationSubDivisionModel = new LocationSubDivisionModel();
  temporaryAddress: LocationSubDivisionModel = new LocationSubDivisionModel();
  addressMatched?: boolean;
}
